import React from "react";
// import { usefilteredProductsContext } from "../context/products_context";
import { useFilterContext } from "../context/filter_context";
import GridView from "./GridView";
import ListView from "./ListView";

const ProductList = () => {
  // const { filteredProducts, loading } = usefilteredProductsContext();
  const { gridView, filteredProducts } = useFilterContext();
  if (gridView) {
    return <>{<GridView filteredProducts={filteredProducts} />}</>;
  }
  return <>{<ListView filteredProducts={filteredProducts} />}</>;
};

export default ProductList;
